import { isDeepEqual } from '@shared/lib/utils/deep-equal/deep-equal';
import { Dispatch, useState } from 'react';

export const useSearchParams = <T extends Object>(
    defaultParams: T,
    resetKeys: string | string[] = 'skip'
): [T, Dispatch<React.SetStateAction<T>>] => {
    const [params, setParams] = useState(defaultParams);

    const setParamsHandler: Dispatch<React.SetStateAction<T>> = (newParams) => {
        const innerParams = typeof newParams === 'function' ? newParams(params) : newParams;
        if (isDeepEqual(innerParams, params, resetKeys)) return setParams(innerParams);
        const resetParams = Array.isArray(resetKeys)
            ? resetKeys.map((key) => ({ [key]: null }))
            : { [resetKeys]: null };
        setParams({
            ...innerParams,
            ...resetParams,
        });
    };

    return [params, setParamsHandler];
};
